'use strict';

/*global services*/
/*global isEmpty*/
/*global replaceAttrKey*/
function RegistrationParamsDefinition($container) {
    this.$container = $container;

    this.init();
}

RegistrationParamsDefinition.prototype = $.extend({}, {
    construtor: 'RegistrationParamsDefinition',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$container.on('change', '.param-definition__title input', function () {
            _this.addParam($(this).closest('.param-definition'));
        });

        _this.$container.on('change', '.param-definition__value input', function () {
            _this.addParamValue($(this).closest('.param-definition'));
        });

        return _this;
    },

    //**************************************************************************

    addParam: function addParam($paramDefinition) {
        var _this = this;

        var $paramDefinitionTitle = $paramDefinition.find('.param-definition__title');
        var title = $paramDefinitionTitle.find('input').val();
        if (!isEmpty(title)) {
            var $cloneParamDefinition = $paramDefinition.clone();
            $cloneParamDefinition.find('input').val('');
            $cloneParamDefinition.find('input:checkbox').removeAttr('checked');
            $cloneParamDefinition.find('.param-definition__value:not(:first)').remove();

            var key = _this.$container.find('.param-definition--new').length;
            $cloneParamDefinition.find('input').each(function () {
                replaceAttrKey($(this), 'name', 1, key);
            });

            $cloneParamDefinition.insertAfter($paramDefinition);
        }

        return _this;
    },

    addParamValue: function addParamValue($paramDefinition) {
        var _this = this;

        var $paramDefinitionValue = $paramDefinition.find('.param-definition__value:last');
        var value = $paramDefinitionValue.find('input').val();
        if (!isEmpty(value)) {
            var $cloneParamDefinitionValue = $paramDefinitionValue.clone();
            $cloneParamDefinitionValue.find('input').val('');
            $cloneParamDefinitionValue.insertAfter($paramDefinitionValue);
        }

        return _this;
    },

    //**************************************************************************    

    init: function init() {
        var _this = this;
      
        _this.registerCallbacks();

        return _this;
    }
});
